/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { faker } from '@faker-js/faker/locale/en';
import { CreateJobContextRequest } from '../JobContext';

export const createMockCreateJobContextRequest = (
  partialRecord: Partial<CreateJobContextRequest> = {},
): CreateJobContextRequest => {
  const numOfEnvVars = faker.number.int({ max: 5, min: 1 });
  const environment: Record<string, string> = {};

  for (let i = 0; i < numOfEnvVars; i++) {
    const key = faker.lorem.word(); // Generate a random key
    const value = faker.lorem.word(); // Generate a random value
    environment[`${key}`] = value;
  }
  return {
    contextName: faker.lorem.word(),
    environment,
    description: faker.lorem.words(),
    ...partialRecord,
  };
};
